module.exports = __webpack_public_path__ + "media/newstyle/images/lp-banner-b-mobile-red-6bd3c73232096da3a6481e1bcf5d0d1a.png";